import Vue from 'vue';
import codemirror from '@/modules/codemirror';
// Add ons
require('codemirror/lib/codemirror.css');
require('codemirror/mode/htmlmixed/htmlmixed');
require('codemirror/addon/hint/show-hint.js');
require('codemirror/addon/hint/show-hint.css');
require('codemirror/addon/edit/matchtags.js');
require('codemirror/addon/hint/javascript-hint.js');
require('codemirror/theme/monokai.css');
require('codemirror/keymap/sublime.js');
require('codemirror/addon/search/search.js');
require('codemirror/addon/search/searchcursor.js');
require('codemirror/addon/search/jump-to-line.js');

export default Vue.component('edit-code-general', {
  template: require('./template.html'),
  components: {
    codemirror,
  },
  computed: {
    editor() {
      return this.$refs.myEditor.editor;
    },
  },
  data() {
    return {
      code: this.droplet.code,
      editorOption: {
        tabSize: 2,
        matchTags: {
          bothTags: true,
        },
        smartIndent: false,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        styleSelectedText: true,
        mode: 'htmlmixed',
        keyMap: 'sublime',
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: 'monokai',
      },
    };
  },
  name: 'edit-code-general',
  props: ['droplet'],
  watch: {
    '$parent.showEditBubble': function wb(o) {
      if (o) {
        setTimeout(() => {
          this.editor.refresh();
        }, 250);
      }
    },
  },
  methods: {
    updateTemplate(code) {
      this._debounce(() => {
        const payload = {};
        payload.drp = this.droplet;
        payload.code = code.trim() === '' ? false : code;
        this.$store.dispatch('updateCode', payload);
      }, 250);
    },
    setHidden(e) {
      const hidden = e.currentTarget.checked;
      const payload = {};
      payload.drp = this.droplet;
      payload.hidden = hidden;
      this.$store.dispatch('setCodeHidden', payload);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/code-general/components/_edit-options/index.js